import { DealerInterressedInfoBoxComponent } from './dealer-interressed-info-box/dealer-interressed-info-box.component';
import { CardInterestedDealersComponent } from './card-interested-dealers/card-interested-dealers.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardVehicleCastOffComponent } from './card-vehicle-cast-off/card-vehicle-cast-off.component';
import { RouterModule } from '@angular/router';
import { MakeBidComponent } from 'src/app/shared/components/cards/make-bid/make-bid.component';
import { MakeFinalBidComponent } from 'src/app/shared/components/cards/make-final-bid/make-final-bid.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuctionStatsComponent } from './auction-stats/auction-stats.component';
import { MomentModule } from 'ngx-moment';
import { DealerInfoBoxComponent } from './dealer-info-box/dealer-info-box.component';
import { MakeAlternativeBidComponent } from './make-alternative-bid/make-alternative-bid.component';
import { AlternativeBindRequestComponent } from './alternative-bind-request/alternative-bind-request.component';
import { EvaluationCardVehicleComponent } from './evaluation-card-vehicle/evaluation-card-vehicle.component';
import { EvaluationHistoryComponent } from './evaluation-history/evaluation-history.component';
import { CardOfferEvaluationComponent } from './card-offer-evaluation/card-offer-evaluation.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CardEvaluationSoldPriceComponent } from './card-evaluation-sold-price/card-evaluation-sold-price.component';
import { FullDossierCardComponent } from './full-dossier-card/full-dossier-card.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { PriceModalModule } from '@app-components/evaluation/evaluation-vehicle-detail/evaluation-price-modal/price-modal.module';
import { FastQuoteComponent } from './fast-quote/fast-quote.component';
import { FastQuoteOfferComponent } from './fast-quote/fast-quote-offer/fast-quote-offer.component';
import { CardVehicleFastQuoteComponent } from './card-vehicle-fast-quote/card-vehicle-fast-quote.component';
import { MakeBidFastQuoteComponent } from './make-bid-fast-quote/make-bid-fast-quote.component';
import { FastQuoteModalComponent } from './fast-quote/fast-quote-modal/fast-quote-modal.component';
import { SharedPipesModule } from '@app-shared/pipes/shared-pipes.module';
import { ExclusiveGroupRequestComponent } from './exclusive-group-request/exclusive-group-request.component';
import { EvalScheduleInfoComponent } from './eval-schedule-info/eval-schedule-info.component';
import { IntegrationHistoryComponent } from './integration-history/integration-history.component';
import { NgxDaterangepickerBootstrapDirective } from 'ngx-daterangepicker-bootstrap';
import { DaterangepickerMatInputDirective } from '@app-shared/directives/daterangepicker-mat-input.directive';
import { DashFipeModule } from '@app-components/dash-fipe/dash-fipe.module';
import { DialogAcceptAlternativeBidComponent } from '@app-components/dialog/dialog-accept-alternative-bid/dialog-accept-alternative-bid.component';
import { CardVehicleHomeComponent } from './card-vehicle-home/card-vehicle-home.component';
import { CardVehicleLoaderComponent } from './card-vehicle-loader/card-vehicle-loader.component';
import { SuperBidHistoryComponent } from './super-bid-history/super-bid-history.component';
import { MatDividerModule } from '@angular/material/divider';
import { EvaluationAxleComponent } from './evaluation-axle/evaluation-axle.component';
import { SuperbidManagementComponent } from './superbid-management/superbid-management.component';
import { CardTitleComponent } from './card-title/card-title.component';
import { CardEvaluationInfoComponent } from './card-evaluation-info/card-evaluation-info.component';
import { CardAxleAndTireComponent } from './card-axle-and-tire/card-axle-and-tire.component';
import { CardTruckCabinComponent } from './card-truck-cabin/card-truck-cabin.component';
import { CardEvaluationOtherInfoComponent } from './card-evaluation-other-info/card-evaluation-other-info.component';
import { CardEquipmentsComponent } from './card-equipments/card-equipments.component';
import { CardRaioXTechnicalComponent } from './card-raio-x-technical/card-raio-x-technical.component';
import { AudioPlayerModule } from '@app-components/audio-player/audio-player.module';
import { ReportItemViewComponent } from '@app-components/report-item-view/report-item-view.component';
import { CardOwnerInfoComponent } from './card-owner-info/card-owner-info.component';
import { DialogAcceptFastQuoteBidComponent } from '@app-components/dialog/dialog-accept-fast-quote-bid/dialog-accept-fast-quote-bid.component';
import { DialogRejectFastQuoteBidComponent } from '@app-components/dialog/dialog-reject-fast-quote-bid/dialog-reject-fast-quote-bid.component';
import { SendLeadComponent } from './send-lead/send-lead.component';
import { AccessAccountModalBodyComponent } from './access-account-modal-body/access-account-modal-body.component';
import { DialogConfirmSendAlternativeBidComponent } from '@app-components/dialog/dialog-confirm-send-alternative-bid/dialog-confirm-send-alternative-bid.component';
import { EvaluationFillProgressBarComponent } from '@app-components/evaluation/evaluation-vehicle-detail/evaluation-fill-progress-bar/evaluation-fill-progress-bar.component';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { DialogDirectSaleComponent } from './auction-management/dialog-direct-sale/dialog-direct-sale.component';
import { DialogFastQuoteRulesComponent } from '@app-components/dialog/dialog-fast-quote-rules/dialog-fast-quote-rules.component';
import { LoaderModule } from '@app-components/loader/loader.module';
import { FeatureAnnouncementComponent } from "@app-components/feature-announcement/feature-announcement.component";
import { SmallFeatureAnnouncementComponent } from '@app-components/small-feature-announcement/small-feature-announcement.component';
import { FipeComparisonBadgeComponent } from '@app-components/fipe-comparison-badge/fipe-comparison-badge.component';
import { EvaluationPriceChangeHistoryComponent } from './evaluation-price-change-history/evaluation-price-change-history.component';
import { TextareaComponent } from '@app-shared/components/ui/textarea/textarea.component';
import { WebhookHistoryComponent } from './webhook-history/webhook-history.component';

const components = [
  AlternativeBindRequestComponent,
  AuctionStatsComponent,
  CardInterestedDealersComponent,
  CardOfferEvaluationComponent,
  CardVehicleCastOffComponent,
  CardVehicleFastQuoteComponent,
  DealerInfoBoxComponent,
  DealerInterressedInfoBoxComponent,
  EvaluationHistoryComponent,
  IntegrationHistoryComponent,
  EvalScheduleInfoComponent,
  ExclusiveGroupRequestComponent,
  FastQuoteComponent,
  FastQuoteModalComponent,
  FastQuoteOfferComponent,
  FullDossierCardComponent,
  MakeAlternativeBidComponent,
  MakeBidComponent,
  MakeBidFastQuoteComponent,
  MakeFinalBidComponent,
  SendLeadComponent,
  DialogAcceptAlternativeBidComponent,
  CardVehicleHomeComponent,
  CardVehicleLoaderComponent,
  SuperBidHistoryComponent,
  EvaluationAxleComponent,
  SuperbidManagementComponent,
  CardTitleComponent,
  CardEvaluationInfoComponent,
  CardAxleAndTireComponent,
  CardTruckCabinComponent,
  CardEvaluationOtherInfoComponent,
  CardEquipmentsComponent,
  CardRaioXTechnicalComponent,
  CardOwnerInfoComponent,
  DialogAcceptFastQuoteBidComponent,
  DialogRejectFastQuoteBidComponent,
  DialogConfirmSendAlternativeBidComponent,
  AccessAccountModalBodyComponent,
  DialogDirectSaleComponent,
  DialogFastQuoteRulesComponent,
  WebhookHistoryComponent,
];

@NgModule({
  declarations: components,
  exports: [
    CommonModule,
    CardEvaluationSoldPriceComponent,
    EvaluationCardVehicleComponent,
    EvaluationFillProgressBarComponent,
    EvaluationPriceChangeHistoryComponent,
    ...components,
    ReportItemViewComponent,
  ],
  imports: [
    LoaderModule,
    RouterModule,
    CommonModule,
    CardEvaluationSoldPriceComponent,
    EvaluationCardVehicleComponent,
    EvaluationFillProgressBarComponent,
    ReportItemViewComponent,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatSlideToggleModule,
    CurrencyMaskModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MomentModule,
    MatCheckboxModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatRadioModule,
    PerfectScrollbarModule,
    NgxPageScrollModule,
    PriceModalModule,
    MatProgressSpinnerModule,
    SharedPipesModule,
    NgxDaterangepickerBootstrapDirective,
    DaterangepickerMatInputDirective,
    DashFipeModule,
    MatTooltipModule,
    MatDividerModule,
    AudioPlayerModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FeatureAnnouncementComponent,
    SmallFeatureAnnouncementComponent,
    EvaluationPriceChangeHistoryComponent,
    FipeComparisonBadgeComponent,
    TextareaComponent,
],
})
export class CardsModule { }
